export default function insertMissedOrderedObjects (arrayWithSkips, expectedUniqueKeys, compareKey,
  objectGenerator, sortFunction) {
  function defaultSortFunction (a, b) {
    if (a[compareKey] > b[compareKey]) {
      return 1;
    }
    if (a[compareKey] < b[compareKey]) {
      return -1;
    }
    return 0;
  }

  if (!objectGenerator) {
    objectGenerator = (i) => ({[compareKey]: i});
  }
  if (!sortFunction) {
    sortFunction = defaultSortFunction;
  }

  const existingKeys = new Set(arrayWithSkips.map(i => i[compareKey]));
  const lostFields = expectedUniqueKeys.filter(i => !existingKeys.has(i));

  const lostArray = lostFields.map(i => objectGenerator(i));

  return [...arrayWithSkips, ...lostArray].sort(sortFunction);
}
